import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  SecurityContext,
} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Directive({
  selector: '[xTentionDummyTooltip]',
  standalone: false,
})
export class TooltipDirective implements OnDestroy {
  @Input() public xTentionDummyTooltip: string;
  @Input() public xTentionDummyTooltipFixByClick: boolean = false;

  private popup;
  private isPopupFixed: boolean = false;

  constructor(
    private elRef: ElementRef,
    private sanitizer: DomSanitizer,
    private domSanitizer: DomSanitizer,
  ) {}

  @HostListener('mouseenter') onMouseEnter() {
    this.showPopup();
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.hidePopup();
  }

  @HostListener('click') onClick() {
    if (this.xTentionDummyTooltipFixByClick) {
      this.isPopupFixed = !this.isPopupFixed;
    }
  }

  private getCoordinates(): { x: number; y: number } {
    const x =
      this.elRef.nativeElement.getBoundingClientRect().left +
      this.elRef.nativeElement.offsetWidth / 2 +
      window.scrollX;

    const y =
      this.elRef.nativeElement.getBoundingClientRect().top +
      this.elRef.nativeElement.offsetHeight +
      window.scrollY;

    return { x, y };
  }

  private showPopup() {
    if (!this.xTentionDummyTooltip || this.popup) return;

    const popup = document.createElement('div');
    popup.setAttribute('class', 'xtention-dummy-tooltip');
    popup.style.top = this.domSanitizer.sanitize(SecurityContext.STYLE, '0');
    popup.style.left = this.domSanitizer.sanitize(SecurityContext.STYLE, '0');

    const content = document.createElement('div');
    content.setAttribute('class', 'xtention-dummy-tooltip__content');
    content.innerHTML = this.sanitizer.sanitize(
      SecurityContext.HTML,
      this.xTentionDummyTooltip,
    );

    popup.appendChild(content);
    document.body.appendChild(popup);
    const { x, y } = this.getCoordinates();
    popup.style.top = this.domSanitizer.sanitize(
      SecurityContext.STYLE,
      `${y}px`,
    );
    popup.style.left = this.domSanitizer.sanitize(
      SecurityContext.STYLE,
      x - popup.offsetWidth / 2 >= 0 ? `${x - popup.offsetWidth / 2}px` : '0px',
    );

    popup.classList.add('xtention-dummy-tooltip__show');

    this.popup = popup;
  }

  private hidePopup(forceHide: boolean = false) {
    if (!this.isPopupFixed || forceHide) {
      this.popup?.remove();
      this.popup = null;
    }
  }

  ngOnDestroy(): void {
    this.hidePopup(true);
  }
}
